import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaGlobe } from "react-icons/fa";
import FamilyWall from "./FamilyWall";
import Cagnottes from "./Cagnottes";
import CalendarSection from "./CalendarSection";
import ChatWindow from "./Messaging/ChatWindow";
import GenealogyTree from "./GenealogyTree";
import FamilyStories from "./FamilyStories";
import InviteMembers from "./InviteMembers";
import PhotoAlbum from "./PhotoAlbum";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isFeatureMenuOpen, setIsFeatureMenuOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([
    "New post on Family Wall",
    "New cagnotte created",
    "New event added",
  ]);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    console.log("🔍 currentUser récupéré :", user);
    if (user) setCurrentUser(user);
    else navigate("/login");
  }, [navigate]);

  const handleNotificationClick = () => {
    setShowNotifications(!showNotifications);
    setNotifications([]);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-blue-600 text-white flex justify-between items-center relative h-16">
        <h1 className="absolute left-4 text-2xl font-bold">
          <Link to="/dashboard" className="text-white hover:text-gray-300">lii</Link>
        </h1>
        <div className="absolute right-4">
          <button
            onClick={() => setIsFeatureMenuOpen(!isFeatureMenuOpen)}
            className="bg-white text-blue-600 px-3 py-1 rounded-full shadow hover:bg-blue-100 font-semibold transition duration-200"
          >
            +
          </button>
          {isFeatureMenuOpen && (
            <div className="absolute top-10 right-0 bg-white rounded-lg shadow-lg w-56 z-50">
             <ul className="p-2 text-gray-900 font-sans font-medium tracking-wide text-lg">
  <li className="p-3 hover:bg-gray-100 cursor-pointer flex items-center gap-2" onClick={() => navigate("/profile")}>
    👤 <span>Profile</span>
  </li>
  <li className="p-3 hover:bg-gray-100 cursor-pointer flex items-center gap-2" onClick={() => navigate("/family-stories")}>
    📖 <span>Anecdotes</span>
  </li>
  <li className="p-3 hover:bg-gray-100 cursor-pointer flex items-center gap-2" onClick={() => navigate("/photo-album")}>
    📷 <span>Album Photo</span>
  </li>
  {/* ✅ Events dans le menu en mode mobile */}
  <li className="p-3 hover:bg-gray-100 cursor-pointer flex items-center gap-2 md:hidden" onClick={() => navigate("/events")}>
    📅 <span>Events</span>
  </li>
</ul>
            </div>
          )}
        </div>
      </header>

      <main className="p-6 flex flex-col md:flex-row space-x-0 md:space-x-4">
        {/* ✅ Family Wall en pleine largeur sur mobile */}
        <div className="w-full md:w-4/5 bg-white p-4 rounded shadow">
          {currentUser && <FamilyWall currentUser={currentUser} />}
        </div>

        {/* ✅ Colonne droite affichée uniquement sur Desktop */}
        <div className="hidden md:block w-1/5 space-y-4">
          <div className="bg-white p-4 rounded shadow">
            <CalendarSection />
          </div>
        </div>
      </main>

      {isChatOpen && (
        <div className="fixed bottom-20 right-4 bg-white w-80 h-96 shadow-lg border-t border-l p-4 z-50">
          <h2 className="text-xl font-semibold mb-2">Messaging</h2>
          <ChatWindow currentUser={currentUser} />
        </div>
      )}

      <button
        onClick={() => setIsChatOpen(!isChatOpen)}
        className="fixed bottom-4 right-4 bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg hover:bg-blue-700 z-50"
      >
        {isChatOpen ? "Fermer le chat" : "Ouvir le chat"}
      </button>
    </div>
  );
};

export default Dashboard; 